var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useMemo } from 'react';
import DataRepository from './DataRepository';
export var MAX_LIMIT = 2147483647;
/**
 * Hook to include a data repository in the given component
 */
export default function useDataRepository() {
    var _this = this;
    var ky = useOkapiKy();
    var servicePoints = useQuery(['ui-calendar', 'service-points'], function () { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky
                        .get("service-points?cql.allRecords=1&limit=".concat(MAX_LIMIT))
                        .json()];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.servicepoints];
            }
        });
    }); });
    var calendars = useQuery(['ui-calendar', 'calendars'], function () { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky
                        .get("calendar/calendars?limit=".concat(MAX_LIMIT))
                        .json()];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.calendars];
            }
        });
    }); });
    var queryClient = useQueryClient();
    var mutationInvalidator = {
        onSuccess: function () {
            queryClient.invalidateQueries(['ui-calendar', 'calendars']);
        }
    };
    var createCalendar = useMutation(function (calendar) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ky
                    .post('calendar/calendars', {
                    json: calendar
                })
                    .json()];
        });
    }); }, mutationInvalidator);
    var putCalendar = useMutation(function (calendar) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ky
                    .put("calendar/calendars/".concat(calendar.id), {
                    json: calendar
                })
                    .json()];
        });
    }); }, mutationInvalidator);
    var deleteCalendars = useMutation(function (calendarsToDelete) { return __awaiter(_this, void 0, void 0, function () {
        var queryString;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryString = calendarsToDelete.map(function (c) { return "id=".concat(c.id); }).join('&');
                    return [4 /*yield*/, ky["delete"]("calendar/calendars?".concat(queryString))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, mutationInvalidator);
    var getDateRange = useMutation(function (_a) {
        var servicePointId = _a.servicePointId, startDate = _a.startDate, endDate = _a.endDate;
        return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ky
                            .get("calendar/dates/".concat(servicePointId, "/all-openings?includeClosed=true&startDate=").concat(startDate, "&endDate=").concat(endDate, "&limit=").concat(MAX_LIMIT))
                            .json()];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, data.dates];
                }
            });
        });
    });
    return useMemo(function () { return new DataRepository(calendars.isSuccess ? calendars.data : undefined, servicePoints.isSuccess ? servicePoints.data : undefined, {
        create: createCalendar.mutateAsync,
        update: putCalendar.mutateAsync,
        "delete": deleteCalendars.mutateAsync,
        dates: getDateRange.mutateAsync
    }); }, [
        calendars.isSuccess,
        calendars.data,
        servicePoints.isSuccess,
        servicePoints.data,
        createCalendar.mutateAsync,
        putCalendar.mutateAsync,
        deleteCalendars.mutateAsync,
        getDateRange.mutateAsync,
    ]);
}
